import { PwaPlatform } from '../types';

export interface IPlatformDetectionInput {
    userAgent: string;
    maxTouchPoints?: number;
    platform?: string;
}

/**
 * Detects coarse mobile platform for install UX.
 * iPadOS 13+ can report as Mac; touch points distinguish it.
 */
export function detectPlatform({ userAgent, maxTouchPoints = 0, platform = '' }: IPlatformDetectionInput): PwaPlatform {
    const ua = userAgent.toLowerCase();
    const isIpadOsDesktopUa = platform === 'MacIntel' && maxTouchPoints > 1;
    const isIos = /iphone|ipad|ipod/.test(ua) || isIpadOsDesktopUa;

    if (isIos) {
        return 'ios';
    }

    if (/android/.test(ua)) {
        return 'android';
    }

    return 'other';
}

export function isMobileUserAgent(userAgent: string, maxTouchPoints = 0, platform = ''): boolean {
    const detected = detectPlatform({ userAgent, maxTouchPoints, platform });
    return detected === 'ios' || detected === 'android';
}
